import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { stuclasslist, studivisionlist } from "../../../services/master";
import { academylist } from "../../../services/admin";
import { studentalumini } from "../../../services/student";

// Alumni (left students) report. Filter by academy (super-admin), class and
// section, with CSV export. The alumni API filters by academy server-side; the
// class/section narrowing is applied client-side on left_student.class/section.
const COLUMNS = [
  { headerName: "Username", field: "username" },
  { headerName: "Name", field: "name" },
  { headerName: "Phone", field: "phone" },
  { headerName: "Class", field: "class_name" },
  { headerName: "Section", field: "section_name" },
  { headerName: "Gender", field: "gender" },
  { headerName: "Left Date", field: "left_date" },
  { headerName: "Academy", field: "academy_name" },
];

const columnDefs = COLUMNS.map((col) => ({
  ...col,
  sortable: true,
  resizable: true,
  filter: true,
  floatingFilter: true,
  cellStyle: { textAlign: "left" },
}));

const AluminiReport = () => {
  const isSuperAdmin = localStorage.getItem("Role") === "1";
  const gridRef = useRef();

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [clist, setCList] = useState([]);
  const [sclass, setSClass] = useState("");
  const [divlist, setDivList] = useState([]);
  const [studiv, setStuDiv] = useState("");
  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    stuclasslist().then((res) => {
      if (res.status === true && res.data.length > 0) {
        setCList(
          res.data.map((item) => ({ value: item.id, label: item.class_name }))
        );
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true && res.data.length > 0) {
        setDivList(
          res.data.map((item) => ({ value: item.id, label: item.name }))
        );
      }
    });

    academylist().then((res) => {
      if (res.status === true && res.data.details.length > 0) {
        const arr = res.data.details.map((item) => ({
          value: item.id,
          label: item.name + " - " + item.code,
        }));
        setACList(arr);

        // Default to the academy chosen at login (matches other report screens).
        let defaultAca = "";
        if (localStorage.getItem("AAcademy") != null) {
          defaultAca =
            arr.find((a) => a.value == localStorage.getItem("AAcademy")) || "";
          if (defaultAca) setAcaID(defaultAca);
        }
        listall(defaultAca, "", "");
      } else {
        listall("", "", "");
      }
    });
  }, []);

  function listall(aca, cl, se) {
    setRowData([]);
    const temp = new FormData();
    if (aca && aca.value) {
      temp.append("academy_id", aca.value);
    }
    studentalumini(temp).then((res) => {
      if (res.status === true) {
        let data = res.data.details || [];
        if (cl && cl.value) data = data.filter((item) => item.class == cl.value);
        if (se && se.value)
          data = data.filter((item) => item.section == se.value);
        setRowData(data);
      }
    });
  }

  function handleAcademy(e) {
    setAcaID(e || "");
    listall(e || "", sclass, studiv);
  }

  function handleClass(e) {
    setSClass(e || "");
    listall(acaid, e || "", studiv);
  }

  function handleSection(e) {
    setStuDiv(e || "");
    listall(acaid, sclass, e || "");
  }

  const exportToCSV = () => {
    const q = (v) => `"${(v == null ? "" : String(v)).replace(/"/g, '""')}"`;
    // Selected-filter context, prepended above the exported grid.
    const prependContent =
      [
        ["Class", sclass ? sclass.label : "All"],
        ["Section", studiv ? studiv.label : "All"],
      ]
        .map((row) => row.map(q).join(","))
        .join("\n") + "\n\n";

    gridRef.current.api.exportDataAsCsv({
      fileName: "Alumni Report.csv",
      allColumns: true,
      prependContent,
    });
  };

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Alumni Report</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Reports</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Alumni Report
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h2 className="main-content-title tx-24 mg-b-5">Alumni Report</h2>
            </div>
            <div className="card-body">
              <div className="row">
                {isSuperAdmin && (
                  <div className="col-xl-3 col-sm-6">
                    <label className="form-label">Select Academy</label>
                    <Select
                      className="default-select"
                      placeholder="Select Academy"
                      value={acaid}
                      options={aclist}
                      onChange={handleAcademy}
                      isSearchable={true}
                      isClearable
                    />
                  </div>
                )}

                <div className="col-xl-3 col-sm-6">
                  <label className="form-label">Select Class</label>
                  <Select
                    className="default-select"
                    placeholder="Select Class"
                    value={sclass}
                    options={clist}
                    onChange={handleClass}
                    isSearchable={true}
                    isClearable
                  />
                </div>

                <div className="col-xl-3 col-sm-6">
                  <label className="form-label">Select Section</label>
                  <Select
                    className="default-select"
                    placeholder="Select Section"
                    value={studiv}
                    options={divlist}
                    onChange={handleSection}
                    isSearchable={true}
                    isClearable
                  />
                </div>

                <div className="col-xl-3 col-sm-6">
                  <div className="res-right mt-5">
                    <button
                      className="btn btn-success me-2"
                      onClick={exportToCSV}
                      disabled={rowData.length === 0}
                    >
                      Excel Download
                    </button>
                  </div>
                </div>
              </div>

              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  ref={gridRef}
                  columnDefs={columnDefs}
                  rowData={rowData}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AluminiReport;
